<template>

 <v-dialog v-model="dialog" width="400px" persistent>
        <v-card>
    <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>     Deseja realmente excluir?</v-toolbar-title>
          <v-spacer></v-spacer>
        
        </v-toolbar>
 
           <v-card-text>
           
                  Essa operação não poderá ser desfeita
        
            </v-card-text>

                    <v-card-actions>
                           <v-btn class="grey" dark text @click="close">
              Cancelar
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn class="red lighten-2" dark text @click="confirm">
              Excluir
            </v-btn>
          </v-card-actions>


        </v-card>
      </v-dialog>

</template>

<script>

export default {
    name: "modal-delete",
    props:["dialog"],
    data(){
        return{

        }
    },
    
    computed: {
      itemsDeviceType:function () {
        var items= [];
        for (var a = 0; a <this.deviceTypes.length; a++){
          items.push( {value:this.deviceTypes[a], text:this.typeNames[this.deviceTypes[a]]});
        }
        // `this` points to the vm instance
        return items;
      }
    },
  
     methods: {
       close(){
          this.$emit("close")
       },
     confirm(){
          this.$emit("confirm")
       },
    }
    
}
</script>


<style scoped>

</style>